"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProps = void 0;
/**
 * Gets properties for the payment step component in the simplified checkout context.
 * Not used in the older separated payment step SPA context.
 * @param configuration Original parsed config from the simplified checkout SPA root element.
 * @returns Payment step component properties.
 */
const getProps = configuration => {
  const result = {
    configuration
  };
  return result;
};
exports.getProps = getProps;